import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { getCurrentUser } from '@aws-amplify/auth';
import * as moment from 'moment';
import { finalize } from 'rxjs';
import { CsReview } from 'src/app/incidencias/incidents.types';
import { IncidentService } from 'src/app/services/api/incident.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dialog-revisionAC',
  templateUrl: './dialog-revisionAC.component.html',
  styleUrls: ['./dialog-revisionAC.component.css']
})
export class DialogRevisionACComponent implements OnInit {
  isEditing: boolean = false;
  isProgramacion: boolean = false;
  isBiblia: boolean = false;
  reviews: CsReview[] = [];
  isLoadingReviews: boolean = false;
  usuario: string = '';

  description: string = '';
  currentDate: string = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Lima'
  }).format(new Date());

  isSaving: boolean = false;
  initialDescription: string = '';
  isRegularized: boolean | null = null;
  initialIsRegularized: boolean | null = null;

  loadingStatusId: string | null = null;

  INCIDENT_STATUS = {
    PENDING: 'PENDING',
    RESOLVED: 'RESOLVED',
    APPROVED: 'APPROVED',
    NOT_APPROVED: 'NOT_APPROVED'
  } as const;

  get isAllApproved(): boolean {
    if (!this.reviews || this.reviews.length === 0) return false;
    return this.reviews.every(
      (r) => r.incidentStatus === this.INCIDENT_STATUS.APPROVED
    );
  }

  constructor(
    public dialogRef: MatDialogRef<DialogRevisionACComponent>,
    @Inject(MAT_DIALOG_DATA)
    public bibliaItem: {
      itineraryId: string;
      activityId?: string;
      activityDay?: number;
      destination?: string;
      activityName?: string;
    },
    private readonly router: Router,
    private readonly incidentService: IncidentService
  ) {}

  private async loadCurrentUser(): Promise<void> {
    try {
      const user = await getCurrentUser();
      this.usuario = user.signInDetails?.loginId || user.username;
      console.log({ user });
      if (!this.usuario) {
        throw new Error('Usuario actual no encontrado o vacío');
      }
    } catch (error) {
      console.error('Error al obtener usuario actual:', error);
      throw error;
    }
  }

  ngOnInit(): void {
    console.log('this.data', this.bibliaItem);
    this.loadCurrentUser();

    this.initialDescription = this.description;

    const url = this.router.url;
    this.isProgramacion =
      url.includes('programacion') ||
      (url.includes('file') && !url.includes('biblia'));
    this.isBiblia = url.includes('biblia');

    this.loadReviews();
  }

  refreshReviews(): void {
    this.loadReviews();
  }

  private loadReviews(): void {
    const itineraryId = this.bibliaItem.itineraryId;
    const activityId = this.bibliaItem.activityId;

    this.isLoadingReviews = true;

    try {
      if (itineraryId && this.isProgramacion) {
        console.log('Llamando findRevisionACByItineraryId...', itineraryId);
        this.incidentService
          .findCSReviewByItineraryId({ itineraryId })
          .pipe(
            finalize(() => {
              console.log('Finalizó llamado findRevisionACByItineraryId');
              this.isLoadingReviews = false;
            })
          )
          .subscribe({
            next: (res: any) => {
              console.log('Response recibido PROGRAMACION:', res);
              this.reviews = res?.findRevisionACByItineraryId || [];
              this.isRegularized = this.reviews.every(
                (r) => r.incidentStatus === this.INCIDENT_STATUS.APPROVED
              );
            },
            error: (err) => {
              console.error('Error requests PROGRAMACION:', err);
            }
          });
      } else if (itineraryId && activityId && this.isBiblia) {
        this.incidentService
          .findCsReviewByActivityId({ itineraryId, activityId })
          .pipe(
            finalize(() => {
              console.log('Finalizó llamado findRevisionACByActivityId');
              this.isLoadingReviews = false;
            })
          )
          .subscribe({
            next: (res: any) => {
              console.log('Response recibido BIBLIA:', res);
              this.reviews = res?.findRevisionACByActivityId || [];

              if (this.reviews.length > 0) {
                const review = this.reviews[0];
                this.description = review.description || '';
                this.initialDescription = this.description;
                this.isRegularized =
                  review.incidentStatus === this.INCIDENT_STATUS.APPROVED;
                this.initialIsRegularized = this.isRegularized;
                this.isEditing = false;
              } else {
                this.isEditing = true;
              }
            },
            error: (err) => {
              console.error('Error requests BIBLIA:', err);
              this.isEditing = true;
            }
          });
      } else {
        console.warn(
          'No se ejecutó ninguna request por falta de parámetros o vista no identificada',
          {
            itineraryId,
            activityId,
            isProgramacion: this.isProgramacion,
            isBiblia: this.isBiblia
          }
        );
        this.isLoadingReviews = false;
      }
    } catch (err) {
      console.error('Error crítico al invocar servicio de revisiones:', err);
      this.isLoadingReviews = false;
      this.isEditing = true;
    }
  }

  hasChanges(): boolean {
    return (
      this.description !== this.initialDescription ||
      this.isRegularized !== this.initialIsRegularized
    );
  }

  saveCsReviewBiblia() {
    if (
      (this.isBiblia && (!this.description || !this.hasChanges())) ||
      this.isSaving ||
      this.bibliaItem.activityId === undefined
    ) {
      console.warn(
        'No se pueden guardar los cambios. Verifique que haya realizado modificaciones, que el comentario no esté vacío y que no haya una operación de guardado en curso.'
      );
      return;
    }

    this.isSaving = true;

    const formatToLimaIso = (date: any) =>
      moment(date).utcOffset('-05:00').format();

    const payload = {
      itineraryId: this.bibliaItem.itineraryId,
      activityId: this.bibliaItem.activityId,
      activityDay: this.bibliaItem.activityDay,
      destination: this.bibliaItem.destination,
      activityName: this.bibliaItem.activityName,
      incidentStatus: this.isRegularized
        ? this.INCIDENT_STATUS.APPROVED
        : this.reviews.length > 0
          ? this.INCIDENT_STATUS.NOT_APPROVED
          : this.INCIDENT_STATUS.PENDING,
      description: this.description,
      incidentDate: formatToLimaIso(this.currentDate),
      createdBy: this.usuario
    };

    console.log({ payload });

    if (this.reviews.length > 0) {
      const review = this.reviews[0];
      this.incidentService
        .updateCSReview({
          incidentId: review.id,
          activityId: payload.activityId,
          itineraryId: payload.itineraryId,
          description: payload.description,
          incidentStatus: payload.incidentStatus,
          modifiedBy: payload.createdBy
        })
        .pipe(
          finalize(() => {
            console.log('Finalizó llamado updateCSReview');
            this.isSaving = false;
          })
        )
        .subscribe({
          next: (res: any) => {
            if (res.updateRevisionAC) {
              Swal.fire({
                title: 'Revisión actualizada',
                text: 'La revisión de A.C. en Biblia fue actualizada con éxito.',
                confirmButtonText: 'Listo',
                confirmButtonColor: '#ea580c',
                allowEscapeKey: false,
                allowOutsideClick: false
              }).then(() => {
                this.isEditing = false;
                this.initialDescription = this.description;
                this.initialIsRegularized = this.isRegularized;
                this.reviews[0].description = this.description;
                if (payload.incidentStatus === this.INCIDENT_STATUS.APPROVED) {
                  this.reviews[0].incidentStatus =
                    this.INCIDENT_STATUS.APPROVED;
                  this.reviews[0].approvedBy = this.usuario;
                }
                if (
                  payload.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
                ) {
                  this.reviews[0].incidentStatus =
                    this.INCIDENT_STATUS.NOT_APPROVED;
                  this.reviews[0].notApprovedBy = this.usuario;
                }
              });
            }
          },
          error: (err) => {
            console.error('Error updating review', err);
            this.isSaving = false;
          }
        });
    } else {
      if (
        payload.activityName == null ||
        payload.destination == null ||
        payload.activityDay == null
      ) {
        console.warn(
          'No se pueden guardar los cambios. Verifique que todos los campos ""activityName, destination y activityDay estén presentes en el payload.'
        );
        Swal.fire({
          title: 'Error al guardar revisión',
          text: 'Faltan datos necesarios para crear la revisión. Verifique que la actividad tenga nombre, destino y día asignados.',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#ea580c'
        });
        return;
      }
      this.incidentService
        .createCSReview({
          activityId: payload.activityId,
          itineraryId: payload.itineraryId,
          activityDay: payload.activityDay,
          destination: payload.destination,
          activityName: payload.activityName,
          description: payload.description,
          incidentStatus: this.isRegularized
            ? this.INCIDENT_STATUS.APPROVED
            : this.INCIDENT_STATUS.PENDING,
          incidentDate: payload.incidentDate,
          createdBy: payload.createdBy
        })
        .pipe(
          finalize(() => {
            console.log('Finalizó llamado createCSReview');
            this.isSaving = false;
          })
        )
        .subscribe({
          next: (res) => {
            console.log({
              res
            });
            Swal.fire({
              title: 'Revisión creada',
              text: 'La revisión de A.C. en Biblia fue creada con éxito.',
              confirmButtonText: 'Listo',
              confirmButtonColor: '#ea580c',
              allowEscapeKey: false,
              allowOutsideClick: false
            }).then(() => {
              this.isEditing = false;
              this.initialDescription = this.description;
              this.initialIsRegularized = this.isRegularized;
              this.reviews.push({
                id: res.createRevisionAC,
                activityId: payload.activityId,
                itineraryId: payload.itineraryId,
                activityDay: payload.activityDay!,
                destination: payload.destination!,
                activityName: payload.activityName!,
                description: payload.description,
                incidentStatus: payload.incidentStatus,
                incidentDate: payload.incidentDate,
                createdBy: payload.createdBy,
                approvedBy: this.isRegularized ? this.usuario : undefined
              });
            });
          },
          error: (err) => {
            console.error('Error creating review', err);
            this.isSaving = false;
          }
        });
    }
  }

  getStyleForComment(): { [key: string]: string } {
    if (this.description === 'aprobado') {
      return {
        color: 'white',
        backgroundColor: 'green',
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid darkgreen'
      };
    } else if (this.description === 'regularizar') {
      return {
        color: 'white',
        backgroundColor: 'red',
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid darkred'
      };
    }
    return {};
  }

  toggleReviewStatusProgramacion(review: CsReview): void {
    let newStatus = review.incidentStatus;
    if (
      review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED ||
      review.incidentStatus === this.INCIDENT_STATUS.PENDING
    ) {
      newStatus = this.INCIDENT_STATUS.RESOLVED;
    } else if (review.incidentStatus === this.INCIDENT_STATUS.RESOLVED) {
      newStatus = this.INCIDENT_STATUS.PENDING;
    }

    this.loadingStatusId = review.id;

    this.incidentService
      .updateCSReview({
        incidentId: review.id,
        itineraryId: review.itineraryId,
        activityId: review.activityId,
        incidentStatus: newStatus,
        modifiedBy: this.usuario
      })
      .pipe(
        finalize(() => {
          console.log('Finalizó llamado updateCSReview status toggle');
          this.loadingStatusId = null;
        })
      )
      .subscribe({
        next: (res) => {
          review.incidentStatus = newStatus;
          if (newStatus === this.INCIDENT_STATUS.RESOLVED) {
            review.resolvedBy = this.usuario;
          }
        },
        error: (err) => {
          console.error('Failed to update status', err);
        }
      });
  }

  updateReviewStatus(review: CsReview, status: string): void {
    this.loadingStatusId = review.id;

    this.incidentService
      .updateCSReview({
        incidentId: review.id,
        itineraryId: review.itineraryId,
        activityId: review.activityId,
        incidentStatus: status,
        modifiedBy: this.usuario
      })
      .pipe(
        finalize(() => {
          console.log('Finalizó llamado updateCSReview status update');
          this.loadingStatusId = null;
        })
      )
      .subscribe({
        next: (res) => {
          review.incidentStatus = status;
          if (status === this.INCIDENT_STATUS.APPROVED) {
            review.approvedBy = this.usuario;
          }

          if (status === this.INCIDENT_STATUS.NOT_APPROVED) {
            review.notApprovedBy = this.usuario;
          }
          console.log('Status updated', res);
        },
        error: (err) => {
          console.error('Failed to update status', err);
        }
      });
  }

  deleteCsReview(): void {
    if (!this.isBiblia || this.reviews.length === 0) return;

    const reviewToDelete = this.reviews[0];

    Swal.fire({
      title: 'Antes de continuar...',
      html: `Si eliminas la revisión de A.C. en Biblia, esta también se eliminará de Programación y no podrá completarse.<br><b>Esta acción no se puede deshacer, ¿deseas continuar?</b>`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.isSaving = true;
        this.incidentService
          .deleteCSReview({
            csReviewId: reviewToDelete.id,
            itineraryId: reviewToDelete.itineraryId,
            activityId: reviewToDelete.activityId,
            deletedBy: this.usuario
          })
          .subscribe({
            next: (res) => {
              this.isSaving = false;
              Swal.fire({
                title: 'Eliminado correctamente',
                text: 'La revisión en Biblia fue eliminada con éxito de Biblia y Programación de Files.',
                confirmButtonText: 'Listo',
                confirmButtonColor: '#ea580c'
              }).then(() => {
                this.reviews = [];
                this.description = '';
                this.isRegularized = null;
                this.isEditing = true;
              });
            },
            error: (err) => {
              this.isSaving = false;
              console.error('Error al invocar eliminación:', err);
              Swal.fire({
                title: 'Error al eliminar observación',
                text: 'No se pudo eliminar la revisión realizada en Biblia. Inténtalo nuevamente.',
                confirmButtonText: 'Reintentar',
                confirmButtonColor: '#ea580c'
              });
            }
          });
      }
    });
  }

  cancelEdit(): void {
    this.description = this.initialDescription;
    this.isRegularized = this.initialIsRegularized;
    this.isEditing = false;
  }

  close(): void {
    this.dialogRef.close(
      this.reviews.length > 0
        ? this.reviews.filter(
            (csR) => csR.incidentStatus !== this.INCIDENT_STATUS.APPROVED
          ).length
        : null
    );
  }
}
